import { inject, Injectable } from '@angular/core';
import { Student } from '@app/models';
import { StudentLifeCycle } from '@app/models/student-life-cycle';
import { StudentDocumentsService } from './student-documents.service';

export interface ProfileValidationResult {
  isValid: boolean;
  missingFields: string[];
  modalMessages: string[];
}

@Injectable({
  providedIn: 'root',
})
export class ProfileValidationService {
  private readonly studentDocumentsService = inject(StudentDocumentsService);

  validateProfileForBooking(student: Student): ProfileValidationResult {
    const missingFields: string[] = [];
    const modalMessages: string[] = [];

    // Validate NEPH
    if (
      (!student?.neph || student.neph.trim() === '') &&
      !student?.hasStartedDriving &&
      !student?.isAllowedToStartDriving
    ) {
      missingFields.push('neph');
      modalMessages.push("Ton Numéro d'Enregistrement Préfectoral Harmonisé (NEPH)");
    }

    // Validate Phone
    if (!student?.phone || student.phone.trim() === '') {
      missingFields.push('phone');
      modalMessages.push('Ton numéro de téléphone');
    }

    // Validate Date of Birth
    if (!student?.dob || student.dob.trim() === '') {
      missingFields.push('dob');
      modalMessages.push('Ta date de naissance');
    }

    return {
      isValid: missingFields.length === 0,
      missingFields,
      modalMessages,
    };
  }

  canBookLessons(student: Student, lifeCycle: StudentLifeCycle): boolean {
    if (lifeCycle.isUserDrivingSuccess) return true;
    if (!student.isAllowedToStartDriving) return false;
    return (
      !!student.codePassedAt ||
      student.drivingEligibilityOverride ||
      this.studentDocumentsService.hasValidDrivingLicense()
    );
  }
}
